import { DownloadOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, DatePicker, Divider, Form, Input, Radio, Select, Space, Upload } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { BASE_URL } from "../../../../apiServices";
import {
  ADD_B2BLC_REMARKS,
  B2BLC_DOCUMENT_UPLOAD,
  B2BLC_REMARKS_LIST,
  IMPORT_B2BLC_INSURANCE_COMPANY_RESOURCE_ENDPOINT,
} from "../../../../apiServices/API_ENDPOINTS";
import { getData, postData } from "../../../../apiServices/common";
import HandleNotification from "../../../../common/Notification";
import { isArrayAndHasValue } from "../../../../utils/functions";
import CustomDatePicker from "common/CustomDatePicker";

const token = localStorage.getItem("token");

const B2bAmendmentTable = (props) => {
  // Props
  const { lcdetailsList, setLcdetailsList, view, SupplierType, b2bLcDate } = props;

  // States
  const [addedReason, setAddedReason] = useState(null);
  const [addedCompany, setAddedCompany] = useState(null);
  const [reasons, setReasons] = useState(null);
  const [insuranceCompanies, setInsuranceCompanies] = useState(null);
  const [companyType, setCompanyType] = useState("both");

  // Antd
  const [lcdetailsForm] = Form.useForm();

  // Others
  const { importId } = useParams();
  const initialLCDetails = {
    unique_id: 1,
    import_b2blc_id: importId ? Number(importId) : null,
    amendment_number: null,
    amendment_date: null,
    amendment_value: null,
    amendment_quantity: null,
    remarks: [],
    insurance_cover_note: null,
    conversion_rate: null,
    date: null,
    insurance_company_id: null,
    lc_amendment_file: null,
    mapped_pis: [],
  };

  const getReasonsList = async (filterValues) => {
    const query = `${B2BLC_REMARKS_LIST}`;
    const bodyData = {
      ...filterValues,
      per_page: filterValues?.per_page || 1000,
    };

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setReasons(response?.data?.data);
    }
  };

  const getInsuranceCompanies = async (filterValues) => {
    const query = `${IMPORT_B2BLC_INSURANCE_COMPANY_RESOURCE_ENDPOINT}`;
    const bodyData = {
      ...filterValues,
      per_page: filterValues?.per_page || 1000,
      no_pagination: true,
    };

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setInsuranceCompanies(response?.data?.data);
    }
  };

  useEffect(() => {
    getReasonsList();
    getInsuranceCompanies();
  }, []);

  const onReasonChange = (event) => {
    setAddedReason(event.target.value);
  };

  const onCompanyChange = (event) => {
    setAddedCompany(event.target.value);
  };

  const addNewReason = async (event) => {
    event.preventDefault();
    const query = `${ADD_B2BLC_REMARKS}`;
    const bodyData = {
      remarks: addedReason,
      import_b2blc_id: importId ? Number(importId) : null,
    };

    const response = await postData(query, bodyData);

    if (response && response?.code === 200) {
      setAddedReason(null);
      HandleNotification("success", "Reason added successfully");
      getReasonsList();
    }
  };

  const addNewCompany = async (event) => {
    event.preventDefault();
    const query = `${IMPORT_B2BLC_INSURANCE_COMPANY_RESOURCE_ENDPOINT}`;
    const bodyData = {
      name: addedCompany,
      type: companyType,
    };
    const response = await postData(query, bodyData);

    if (response && response?.code === 200) {
      setAddedCompany(null);
      HandleNotification("success", "Company added successfully");
      getInsuranceCompanies();
    }
  };

  const addRow = (unique_id) => {
    const lcDetailsListCopy = isArrayAndHasValue(lcdetailsList) ? [...lcdetailsList] : [];
    const newData = {
      ...initialLCDetails,
      unique_id: isArrayAndHasValue(lcDetailsListCopy)
        ? lcDetailsListCopy[lcDetailsListCopy.length - 1].unique_id + 1
        : 0,
      amendment_number: `AMENDMENT ${lcDetailsListCopy.length}`,
      createFromAmendmentDetails: true,
    };
    lcDetailsListCopy.push(newData);
    setLcdetailsList(lcDetailsListCopy);
  };

  const removeRow = (unique_id) => {
    const lcDetailsListCopy = [...lcdetailsList];
    const newData = lcDetailsListCopy.filter((item) => item?.unique_id !== unique_id);
    setLcdetailsList(newData);
  };

  const onChangeLCValue = (value, index, keyName) => {
    // Copy poDetailsData state array
    const lcDetailsDataCopy = [...lcdetailsList];
    const foundLCItem = lcDetailsDataCopy?.find((item) => item?.unique_id === index);
    foundLCItem[keyName] = value;

    setLcdetailsList(lcDetailsDataCopy);
  };

  const onUploadFile = (info, key) => {
    const fileResponse = info?.file?.response?.code === 200 ? info?.file?.response?.data : null;
    if (fileResponse) {
      onChangeLCValue(fileResponse, key, "lc_amendment_file");
    }
  };

  return (
    <Form form={lcdetailsForm}>
      <div>
        <Card title={<span style={{ fontSize: "14px" }}>Amendment Details</span>}>
          <div className="custome-table">
            <table>
              <thead>
                <tr>
                  <th className="t-header" colSpan="2">
                    {" "}
                  </th>
                  <th className="t-header bc-java " colSpan="2">
                    Change
                  </th>
                </tr>
                <tr>
                  <th key="header_initial_amendment" className="bc-java ">
                    Initial/Amendment{" "}
                  </th>
                  <th key="header_amendment_date" className="bc-java ">
                    LC/Amendment Date{" "}
                  </th>
                  <th key="header_lc_qty" className="bc-java ">
                    LC Quantity{" "}
                  </th>
                  <th key="header_lc_value" className="bc-java ">
                    LC Value{" "}
                  </th>
                  {SupplierType === "Foreign" && (
                    <>
                      <th key="header_conversion_rate" className="bc-java ">
                        Conversion Rate{" "}
                      </th>
                      <th key="header_reason" className="bc-java ">
                        Insurance Cover Note{" "}
                      </th>
                      <th key="header_date" className="bc-java ">
                        Date{" "}
                      </th>
                      <th key="header_insurance_company" className="bc-java ">
                        Insurance Company{" "}
                      </th>
                    </>
                  )}
                  {lcdetailsList?.length > 1 && (
                    <th key="header_reason" className="bc-java ">
                      Reason of Amendment{" "}
                    </th>
                  )}
                  <th key="header_document" className="bc-java ">
                    Document{" "}
                  </th>
                  <th key="header_upload" className="bc-java ">
                    Upload{" "}
                  </th>
                  {/* <th key="header_add" className="bc-java ">
                    Add{" "}
                  </th> */}
                  <th key="header_remove" className="bc-java ">
                    Rmv{" "}
                  </th>
                </tr>
              </thead>

              <tbody className="scrollable-table-container">
                {isArrayAndHasValue(lcdetailsList) &&
                  lcdetailsList?.map((item, index) => {
                    return (
                      <tr key={`table_parent_key_${index}`}>
                        {/* INITIAL/AMENDMENT */}
                        <td className="t-body">
                          <Form.Item
                            style={{ marginBottom: "unset" }}
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: "Please Insert Extra Cutting!",
                            //   },
                            // ]}
                          >
                            <Input
                              name={`amendment_number_${index}`}
                              value={item?.amendment_number || ""}
                              onChange={(event) => {
                                let context = "amendment_number";
                                onChangeLCValue(event.target.value, item?.unique_id, context);
                              }}
                              size="small"
                              placeholder="Initial/Amendment"
                              disabled={true}
                            />
                          </Form.Item>
                        </td>
                        {/* LC/Amendment Date */}
                        <td className="t-body">
                          <Form.Item style={{ marginBottom: "unset" }}>
                            <CustomDatePicker
                              style={{ width: "100%" }}
                              placeholder="LC/Amendment Date"
                              size="small"
                              value={item?.amendment_number === null && !importId ? b2bLcDate : item?.amendment_date}
                              onChange={(date, dateString) => {
                                let context = "amendment_date";
                                onChangeLCValue(date, item?.unique_id, context);
                              }}
                              disabled={item?.amendment_number === null || item?.amendment_number === "Initial" || view}
                            />
                          </Form.Item>
                        </td>
                        {/* LC QUANTITY */}
                        <td className="t-body">
                          <Form.Item
                            style={{ marginBottom: "unset" }}
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: "Please Insert Extra Cutting!",
                            //   },
                            // ]}
                          >
                            <Input
                              name={`export_lc_qty_${index}`}
                              value={item?.amendment_quantity || ""}
                              onChange={(event) => {
                                let context = "amendment_quantity";
                                onChangeLCValue(event.target.value, item?.unique_id, context);
                              }}
                              size="small"
                              placeholder="LC Quantity"
                              disabled={true}
                              // disabled={
                              //   item?.amendment_number === "Initial" || view
                              // }
                            />
                          </Form.Item>
                        </td>
                        {/* LC VALUE */}
                        <td className="t-body">
                          <Form.Item style={{ marginBottom: "unset" }}>
                            <Input
                              name={`amendment_value_${index}`}
                              value={item?.amendment_value || ""}
                              onChange={(event) => {
                                let context = "amendment_value";
                                onChangeLCValue(event.target.value, item?.unique_id, context);
                              }}
                              size="small"
                              placeholder="LC Value"
                              disabled={true}
                              // disabled={
                              //   item?.amendment_number === "Initial" || view
                              // }
                            />
                          </Form.Item>
                        </td>

                        {/* Insurance Cover Note */}
                        {SupplierType === "Foreign" && (
                          <>
                            <td className="t-body">
                              <Form.Item style={{ marginBottom: "unset" }}>
                                <Input
                                  name={`conversion_rate_${index}`}
                                  value={item?.conversion_rate || ""}
                                  onChange={(event) => {
                                    let context = "conversion_rate";
                                    onChangeLCValue(event.target.value, item?.unique_id, context);
                                  }}
                                  size="small"
                                  placeholder="Conversion Rate"
                                  disabled={view}
                                  // disabled={
                                  //   item?.amendment_number === "Initial" || view
                                  // }
                                />
                              </Form.Item>
                            </td>
                            <td className="t-body">
                              <Form.Item style={{ marginBottom: "unset" }}>
                                <Input
                                  name={`insurance_cover_note_${index}`}
                                  value={item?.insurance_cover_note || ""}
                                  onChange={(event) => {
                                    let context = "insurance_cover_note";
                                    onChangeLCValue(event.target.value, item?.unique_id, context);
                                  }}
                                  size="small"
                                  placeholder="Insurance Cover Note"
                                  // disabled={item?.amendment_number === "Initial" || view}
                                  disabled={view}
                                />
                              </Form.Item>
                            </td>

                            <td className="t-body">
                              <Form.Item style={{ marginBottom: "unset" }}>
                                <CustomDatePicker
                                  style={{ width: "100%" }}
                                  placeholder="Date"
                                  size="small"
                                  value={item?.date}
                                  onChange={(date, dateString) => {
                                    let context = "date";
                                    onChangeLCValue(date, item?.unique_id, context);
                                  }}
                                  disabled={view}
                                />
                              </Form.Item>
                            </td>

                            {/* Insurance Company OF AMENDMENT */}
                            <td className="t-body">
                              <Form.Item style={{ marginBottom: "unset" }}>
                                <Select
                                  style={{
                                    width: "200px",
                                  }}
                                  size="small"
                                  placeholder="Insurance Company"
                                  mode="single"
                                  onSelect={(value) => {
                                    const context = "insurance_company_id";
                                    onChangeLCValue(value, item?.unique_id, context);
                                  }}
                                  onDeselect={(value) => {
                                    const context = "insurance_company_id";
                                    onChangeLCValue(null, item?.unique_id, context);
                                  }}
                                  value={item?.insurance_company_id}
                                  disabled={view}
                                  // dropdownRender={(menu) => (
                                  //   <>
                                  //     {menu}
                                  //     <Divider
                                  //       style={{
                                  //         margin: "8px 0",
                                  //       }}
                                  //     />
                                  //     <Space
                                  //       style={{
                                  //         padding: "0 8px 4px",
                                  //       }}
                                  //     >
                                  //       <Input
                                  //         placeholder="Enter new Company"
                                  //         size="small"
                                  //         value={addedCompany}
                                  //         onChange={onCompanyChange}
                                  //         // ref={inputRef}
                                  //       />
                                  //       <span
                                  //         onClick={addNewCompany}
                                  //         style={{
                                  //           cursor: "pointer",
                                  //           fontSize: "14px",
                                  //           color: "#131414ff",
                                  //         }}
                                  //       >
                                  //         <PlusOutlined />
                                  //       </span>
                                  //     </Space>
                                  //   </>
                                  // )}
                                  dropdownRender={(menu) => (
                                    <div
                                      onMouseDown={(e) => {
                                        // Prevent dropdown from closing when clicking inside, but allow input to focus
                                        const target = e.target;
                                        // Only prevent default if clicking on the wrapper div itself, not on input/button/radio
                                        if (
                                          target.tagName !== "INPUT" &&
                                          target.tagName !== "BUTTON" &&
                                          !target.closest("input") &&
                                          !target.closest("button") &&
                                          !target.closest(".ant-radio-button")
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    >
                                      {menu}
                                      <Divider
                                        style={{
                                          margin: "8px 0",
                                        }}
                                      />
                                      <Space
                                        direction="vertical"
                                        style={{
                                          padding: "0 8px 4px",
                                          width: "100%",
                                        }}
                                        size="small"
                                      >
                                        {addedCompany && addedCompany.trim() && (
                                          <div>
                                            <div style={{ marginBottom: "4px", fontSize: "12px", color: "#666" }}>
                                              Type:
                                            </div>
                                            <Radio.Group
                                              value={companyType}
                                              onChange={(e) => {
                                                setCompanyType(e.target.value);
                                              }}
                                              size="small"
                                              style={{ width: "100%" }}
                                              buttonStyle="solid"
                                            >
                                              {/* <Radio.Button value="export">Export</Radio.Button> */}
                                              <Radio.Button value="import">Import</Radio.Button>
                                              <Radio.Button value="both">Both</Radio.Button>
                                            </Radio.Group>
                                          </div>
                                        )}
                                        <Space style={{ width: "100%" }}>
                                          <Input
                                            placeholder="Enter new Insurance Company"
                                            size="small"
                                            value={addedCompany}
                                            onChange={onCompanyChange}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                e.preventDefault();
                                                addNewCompany(e);
                                              }
                                            }}
                                            onMouseDown={(e) => {
                                              // Allow input to receive focus
                                              e.stopPropagation();
                                            }}
                                            onClick={(e) => {
                                              // Allow input to receive focus
                                              e.stopPropagation();
                                            }}
                                            style={{ flex: 1 }}
                                          />
                                          <Button type="text" icon={<PlusOutlined />} onClick={addNewCompany}>
                                            Add
                                          </Button>
                                        </Space>
                                      </Space>
                                    </div>
                                  )}
                                  options={insuranceCompanies?.map((item) => ({
                                    label: item?.name || "",
                                    value: item?.id,
                                  }))}
                                />
                              </Form.Item>
                            </td>
                          </>
                        )}

                        {/* REASON OF AMENDMENT */}
                        {lcdetailsList?.length > 1 && (
                          <td className="t-body">
                            <Form.Item style={{ marginBottom: "unset" }}>
                              <Select
                                style={{
                                  width: "100%",
                                }}
                                size="small"
                                placeholder="Reasons"
                                mode="multiple"
                                onSelect={(value) => {
                                  const context = "remarks";
                                  const reasons_data = item?.remarks;
                                  reasons_data.push(value);
                                  onChangeLCValue(reasons_data, item?.unique_id, context);
                                }}
                                onDeselect={(value) => {
                                  const context = "remarks";
                                  const reasons_data = item?.remarks;
                                  const filteredReasons = reasons_data?.filter((item) => item !== value);
                                  onChangeLCValue(filteredReasons, item?.unique_id, context);
                                }}
                                value={item?.remarks}
                                disabled={
                                  item?.amendment_number === null || item?.amendment_number === "Initial" || view
                                }
                                dropdownRender={(menu) => (
                                  <>
                                    {menu}
                                    <Divider
                                      style={{
                                        margin: "8px 0",
                                      }}
                                    />
                                    <Space
                                      style={{
                                        padding: "0 8px 4px",
                                      }}
                                    >
                                      <Input
                                        placeholder="Enter new reason"
                                        size="small"
                                        value={addedReason}
                                        onChange={onReasonChange}
                                        // ref={inputRef}
                                      />
                                      <Button type="text" icon={<PlusOutlined />} size="small" onClick={addNewReason} />
                                    </Space>
                                  </>
                                )}
                                options={reasons?.map((item) => ({
                                  label: item?.remarks || "",
                                  value: item?.id,
                                }))}
                              />
                            </Form.Item>
                          </td>
                        )}

                        {/* DOCUMENT */}
                        <td className="t-body">
                          <Form.Item
                            style={{ marginBottom: "unset" }}
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: "Please Insert Extra Cutting!",
                            //   },
                            // ]}
                          >
                            <span>
                              <a
                                href={`${BASE_URL}/${item?.lc_amendment_file?.document}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {item?.lc_amendment_file?.document_name
                                  ? `${item?.lc_amendment_file?.document_name?.slice(0, 10)}...`
                                  : ""}
                              </a>
                            </span>
                          </Form.Item>
                        </td>
                        {/* UPLOAD BUTTON */}
                        <td className="t-body">
                          <Upload
                            // action={`${BASE_URL}${B2BLC_DOCUMENT_UPLOAD}`}
                            action={
                              importId
                                ? `${BASE_URL}${B2BLC_DOCUMENT_UPLOAD}?b2b_lc_id=${importId}&item_unique_id=${item?.unique_id}`
                                : `${BASE_URL}${B2BLC_DOCUMENT_UPLOAD}`
                            }
                            accept={"image/*,.pdf, .doc, .xlsx"}
                            headers={{
                              authorization: `Bearer ${token}`,
                            }}
                            showUploadList={false}
                            onChange={(info) => onUploadFile(info, item?.unique_id)}
                          >
                            <Button type="primary" icon={<DownloadOutlined />} size="small" disabled={view}>
                              Upload
                            </Button>
                          </Upload>
                        </td>
                        {/* ADD BUTTON */}
                        {/* <td
                          className="t-body"
                          onClick={() => {
                            addRow(item?.unique_id);
                          }}
                        >
                          <PlusCircleOutlined
                            className="cursore-pointer"
                            style={{ fontSize: "16px", color: "Green" }}
                          />
                        </td> */}
                        <td
                          className="t-body"
                          onClick={() => {
                            // Disable the remove icon for the first item with "Initial/Amendment" set to "Initial"
                            // Enable it for the last item
                            if (index === 0 && item?.amendment_number === "Initial") {
                              return;
                            }
                            if (index === lcdetailsList.length - 1) {
                              removeRow(item?.unique_id);
                            }
                          }}
                        >
                          <MinusCircleOutlined
                            className={`cursore-pointer ${
                              index === 0 && item?.amendment_number === "Initial" ? "disabled-icon" : ""
                            }`}
                            style={{
                              fontSize: "16px",
                              // color: "Red"
                              color:
                                (index === 0 && item?.amendment_number === "Initial") ||
                                index != lcdetailsList.length - 1
                                  ? "grey"
                                  : "red", // Muted color
                              cursor:
                                (index === 0 && item?.amendment_number === "Initial") ||
                                index != lcdetailsList.length - 1
                                  ? "not-allowed"
                                  : "pointer", // Disabled cursor
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {importId && (
              <Button type="primary" size="small" style={{ marginTop: 10 }} onClick={addRow} disabled={view}>
                Add New
              </Button>
            )}
          </div>
        </Card>
      </div>
    </Form>
  );
};

export default B2bAmendmentTable;
